import React, { useState } from 'react'
import { Button, Card, Col, Row, Select, Space, Typography } from "antd";
import { ProductVersionModel } from '../../../models/product-interface';
import { SupportTier } from '../../../models/support-tier-interface';
import { RatePlan } from '../../../models/rate-plan-interface';
import { ProductRatePlan, ProductSupport } from '../../../models/product-rate-plan-interface';
import SupportRadioList from './SupportRadioList';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';

const { Title } = Typography

type Props = {
  productId: number | null;
  allRatePlans: ProductRatePlan[];
  selectedRatePlans: ProductSupport[];
  allSupportTiers: SupportTier[];
}

const RatePlanSelectCard: React.FC<Props> = ({
  productId,
  allRatePlans,
  selectedRatePlans,
  allSupportTiers
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedRatePlan, setSelectedRatePlan] = useState<string | null>(null);
  const [selectedSupportTier, setSelectedSupportTier] = useState<number | null>(null);
  const updateSupportTierMutator = CustomerServiceQueries.useUpdateProductSupport(productId);
  
  const saveProductTier = () => {
    setIsLoading(true);
    let data = {
      productId,
      ratePlanId: selectedRatePlan,
      supportTier: allSupportTiers.find(x => x.id == selectedSupportTier) as SupportTier
    }

    updateSupportTierMutator.mutateAsync(data).then(() => {
      setSelectedRatePlan(null);
      setSelectedSupportTier(null);
    }).finally(() => {
      setIsLoading(false);
    })
  }

  return <Card className='cost-card'>
    <Space direction="vertical" className="full-width">
      <Title level={5}>
        Rate Plan
      </Title>
      <Select
        style={{ minWidth: 300 }}
        placeholder="Select Rate Plan"
        value={selectedRatePlan}
        onChange={(val) => {
          setSelectedRatePlan(val)
        }}
        allowClear
      >
        {allRatePlans.map(plan => (
          <Select.Option key={plan.id} value={plan.id} disabled={selectedRatePlans.some(x => x.ratePlanId == plan.id)}>
            {plan.name}
          </Select.Option>
        ))}
      </Select>
      {!!selectedRatePlan && (
        <Row gutter={[16, 16]} >
          <Col span={24}>
            <Title level={5}>
              Change Default Tier
            </Title>
          </Col>
          <Col span={24}>
            <SupportRadioList
              setSelectedSupportTierId={setSelectedSupportTier}
              selectedSupportTierId={selectedSupportTier}
              allSupportTiers={allSupportTiers}
            />
          </Col>
          <Col flex="auto" />
          <Col>
            <Button onClick={() => setSelectedRatePlan(null)}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => saveProductTier()}
              loading={isLoading}
            >
              Save
            </Button>
          </Col>
        </Row>
      )}
    </Space>
  </Card>
}

export default RatePlanSelectCard;